// Соответствие демо-странцы Styleguidist к борду из Styleguide.
const figmaBoardToStyleguidistComponentMap: Record<string, string> = {
    //// Раздел Web
    // AccordionForm.
    '37916:39291': '/#!/Components/AccordionForm?styleguideLive=true',
    // AccordionView.
    '35237:8': '/#!/Components/AccordionView?styleguideLive=true',
    // Alerts.
    '14376:31266': '/#!/Components/Alerts?styleguideLive=true',
    // Buttons.
    '25049:3303': '/#!/Components/Buttons?styleguideLive=true',
    // Calendar.
    '37926:51369': '/#!/Components/Calendar?styleguideLive=true',
    // Cards.
    '37926:57695': '/#!/Components/Cards?styleguideLive=true',
    // Checkboxes.
    '37934:63837': '/#!/Components/Checkboxes?styleguideLive=true',
    // Date Picker.
    '37934:66332': '/#!/Components/DatePicker?styleguideLive=true',
    // Date Range.
    '71620:40887': '/#!/Components/DateRange?styleguideLive=true',
    // Divider.
    '37937:68968': '/#!/Components/Divider?styleguideLive=true',
    // Inputs.
    '14699:34852': '/#!/Components/Inputs?styleguideLive=true',
    // Labels.
    '32949:1020': '/#!/Components/Labels?styleguideLive=true',
    // LightBox.
    '25555:3': '/#!/Components/LightBoxes?styleguideLive=true',
    // Links.
    '15930:28210': '/#!/Components/Link?styleguideLive=true',
    // MarkerStatus.
    '34708:1': '/#!/Components/MarkerStatus?styleguideLive=true',
    // ModalWindow.
    '24603:39596': '/#!/Components/Modal%20windows?styleguideLive=true',
    // Multiselect.
    '35665:25153': '/#!/Components/Multiselect?styleguideLive=true',
    // Notification Business.
    '31990:87': '/#!/Components/Notification?styleguideLive=true',
    // Notification System.
    '15442:1157': '/#!/Components/Notification?styleguideLive=true',
    // Page.
    '37197:37261': '/#!/Components/Page?styleguideLive=true',
    // PageHeader.
    '14389:31970': '/#!/Components/HeaderPage?styleguideLive=true',
    // PageFooter.
    '14962:33211': '/#!/Components/FooterPage?styleguideLive=true',
    // Radio Group.
    '30932:2890': '/#!/Components/RadioGroup?styleguideLive=true',
    // SegmentedControl.
    '32478:68555': '/#!/Components/SegmentedControl?styleguideLive=true',
    // Selects.
    '34678:19084': '/#!/Components/Selects?styleguideLive=true',
    // Spoiler.
    '34733:20225': '/#!/Components/Spoiler?styleguideLive=true',
    // Suggest.
    '34698:1': '/#!/Components/Suggest?styleguideLive=true',
    // Table.
    '32879:0': '/#!/Components/TableBasic?styleguideLive=true',
    // Tabs.
    '38038:37281': '/#!/Components/Tabs?styleguideLive=true',
    // TabsFolder.
    '37903:38724': '/#!/Components/TabsFolder?styleguideLive=true',
    // Tag.
    '34676:1': '/#!/Components/Tag?styleguideLive=true',
    // TextField.
    '72168:47453': '/#!/Components/TextField?styleguideLive=true',
    // Tooltip.
    '14964:33366': '/#!/Components/Tooltip?styleguideLive=true',
    // Widget.
    '34431:24523': '/#!/Components/Widget?styleguideLive=true',
    // Stepper.
    '70226:38416': '/#!/Components/Stepper?styleguideLive=true',
    // StatusTracker.
    '70446:45635': '/#!/Components/StatusTracker?styleguideLive=true',
    // UploadZone.
    '36264:0': '/#!/Components/UploadZone?styleguideLive=true',
    //// Раздел Super
    // Illustrations.
    '34939:12018': '/#!/Icons%20and%20Illustrations/Illustrations?styleguideLive=true',
    // Icon Set. Principles.
    '34751:0': '/#!/Icons%20and%20Illustrations/Icons?styleguideLive=true',
    // Icon Set. Design.
    '34866:11691': '/#!/Icons%20and%20Illustrations/Icons?styleguideLive=true',
    // Icon Set. Types.
    '34864:2': '/#!/Icons%20and%20Illustrations/Icons?styleguideLive=true',
    // Skeleton.
    '36285:12082': '/#!/Components/Skeleton?styleguideLive=true',
    // Sliders.
    '37099:32657': '/#!/Slider?styleguideLive=true',

}

const LivePreviewUtils = {
    styleguidistHost: process.env.REACT_APP_STYLEGUIDIST_HOST,

    // Возвращает путь демо-страницы для борда.
    getLiveDemoPathFromBoardId: (boardId: string): string | undefined => figmaBoardToStyleguidistComponentMap[boardId]
}

export default LivePreviewUtils;
